import { useSearchParams } from "react-router-dom"
import PageLayout from "../../layouts/PageLayout"
import ConfigTopBar, { TCBarItem } from "./components/ConfigTopBar"
import EducationLevels from "./components/EducationLevels"
import ExamsConfigs from "./components/ExamsConfigs"

const Configurations = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selTab = (searchParams.get('tab') as TCBarItem) || 'Education Levels';

  const setSelTab = (tab: TCBarItem) => {
    setSearchParams({ tab });
  };

  return (
    <PageLayout label='Configurations' >
      <div className="max-w-7xl mx-auto h-full flex flex-col px-4 py-6" >
        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-extrabold text-gray-900 tracking-tight">System Configurations</h1>
          <p className="mt-2 text-lg text-gray-500 max-w-2xl">
            Manage your educational levels, exams, and subjects. These settings will be applied across the entire platform.
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="mb-8 sticky top-0 z-20 bg-gray-50/80 backdrop-blur-md py-4 rounded-xl">
          <ConfigTopBar selected={selTab} onClick={(a) => setSelTab(a)} />
        </div>

        {/* Main Content Area */}
        <div className="flex-1 min-h-0" >
          {selTab === 'Education Levels' && <EducationLevels />}
          {selTab === 'Exams' && <ExamsConfigs />}
        </div>
      </div>
    </PageLayout>
  )
}

export default Configurations